<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-select v-model="queryParam.batchId" @change="getSpecialtyList" placeholder="选择考试" filterable style="width:200px;margin-right:10px;">
          <el-option v-for="(item,index) in batchList" :key="index" :label="item.batchName" :value="item.batchId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-select v-model="queryParam.specialtyId" placeholder="所属专业" @change="getPage({pageNum: 1})" filterable clearable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in specialtyList" :key="index" :label="item.specialtyName" :value="item.specialtyId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
      </div>
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium">
        <el-table-column prop="categoryName" label="所属分类"></el-table-column>
        <el-table-column prop="specialtyName" label="所属专业"></el-table-column>
        <el-table-column prop="gradeList" label="所属级别">
          <template slot-scope="scope">
            {{Tool.joinList(scope.row.gradeList,'gradeName','/')}}
          </template>
        </el-table-column>
        <el-table-column prop="examFeeList" label="基本费用明细">
          <template slot-scope="scope">
            <span v-for="(item,index) in scope.row.examFeeList" :key="index">{{item.examFeeName}}:{{item.examFee}};</span>
          </template>
        </el-table-column>
        <el-table-column prop="auditStatus" label="浮动比例">
          <template slot-scope="scope">
            {{scope.row.feeLowerRate}}%-{{scope.row.feeUpperRate}}%
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="edit(scope.row)">申请考级点费用</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
    <el-dialog title="申请考级点费用" v-if="editForm.show" :visible.sync="editForm.show" width="800px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <Edit :row="editForm.row" @close="getPage()"></Edit>
    </el-dialog>
  </div>
</template>
<script>
import Edit from './fee-edit'

export default {
  name: 'list',
  components: { Edit },
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: { batchId: this.$route.query.batchId, specialtyId: this.$route.query.specialtyId },
      page: { pageSize: 20, pageNum: 1 },
      editForm: { show: false, row: null },
      batchList: [],
      specialtyList: []
    }
  },
  async created () {
    this.batchList = await this.$HTTP.ApiBatch.getList({ isFeeAudit: 1, batchStatus: [2] })
    if (this.Tool.isNull(this.batchList)) {
      throw new Error('没有考试数据')
    }
    if (!this.queryParam.batchId) {
      this.queryParam.batchId = this.batchList[0].batchId
    }
    await this.getSpecialtyList()
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async getSpecialtyList (event) {
      this.specialtyList = await this.$HTTP.ApiSpecialty.getList({ batchId: this.queryParam.batchId })
      if (event) {
        this.queryParam.specialtyId = ''
      }
      await this.getPage()
    },
    async getPage (queryParam) {
      try {
        this.editForm.show = false
        this.editForm.row = null
        this.queryParam = Object.assign({}, this.queryParam, queryParam)
        let page = await this.$HTTP.ApiFeeAudit.getPageSpecialty(this.queryParam)
        this.page = page
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async edit (row) {
      try {
        if (Number(row.auditStatus) === 1) {
          throw new Error('您提交的申请正在审核，请先取消申请')
        } else if (Number(row.auditStatus) === 2) {
          let confirm = await this.$confirm('您已完成审核，是否确认重新申请？', '提示', { type: 'warning' })
          if (confirm === 'confirm') {
            this.editForm.show = true
            if (row) {
              this.editForm.row = row
            } else {
              this.editForm.row = null
            }
          }
        } else {
          this.editForm.show = true
          if (row) {
            this.editForm.row = row
          } else {
            this.editForm.row = null
          }
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    }
  }
}
</script>
